import { createSelector } from "@ngrx/store";
import { RootStoreState } from "./state";

/* Data state selectors */
export const selectSubscriptionRequest = createSelector(
    (state: RootStoreState) => state,
    (state: RootStoreState) => state.dataState.conversationState.subscriptionRequest
);

/* UI state selectors */
export const selectIsLoading = createSelector(
    (state: RootStoreState) => state,
    (state: RootStoreState) => state.uiState.isLoading
);

export const selectServerError = createSelector(
    (state: RootStoreState) => state,
    (state: RootStoreState) => state.uiState.serverError
);

export const selectServerErrorEmail = createSelector(
    (state: RootStoreState) => state,
    (state: RootStoreState) => state.uiState.serverErrorEmail
);